import React, { useState, useMemo, useEffect } from 'react';
import css from './styles.module.scss';
import { useSelector } from 'react-redux';
import { Grid, makeStyles, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Search } from '~/common/search';
import { DateRange, DateRangeDelimiter, DateRangePicker, LocalizationProvider } from '@material-ui/pickers-next';
import MomentUtils from '@material-ui/pickers-next/adapter/moment';
import { ChipsFilter } from '~/common/chips-filter';
import { selectDeals } from '~/features/dashboard/store/selectors';
import { useDateFormat } from '~/common/date-format';

interface RightDrawerProps {}

const useStyle = makeStyles(theme => ({
    rightdrawer: {
        flexGrow: 1,
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '10px',
    },
    addAndSearch: {
        minWidth: '350px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    filterChipsSeaction: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '350px',
    },
    startToendDate: {
        // minWidth: '350px',
        maxWidth: '350px',
    },
    rightdrawerCards: {},
}));

export const RightDrawer: React.FC<RightDrawerProps> = () => {
    const { selectedDateFormat } = useDateFormat();
    const deals = useSelector(selectDeals);
    // const [filteredDeals, setFilteredDeals] = useState<Deal[]>([]);
    const [dealTypesFilter, setDealTypesFilter] = useState<string[]>([]);
    const [dealStatusFilter, setDealStatusFilter] = useState<string[]>([]);
    const [searchValue, setSearchValue] = useState('');
    const [dateFilter, setDateFilter] = React.useState<DateRange<Date>>([null, null]);

    const classNames = useStyle();

    const types = useMemo(() => {
        const dealTypes: string[] = [];
        for (const deal of deals) {
            if (deal.dealType.trim() && !dealTypes.includes(deal.dealType)) {
                dealTypes.push(deal.dealType);
            }
        }
        return dealTypes;
    }, [deals]);

    const statuses = useMemo(() => {
        const dealStatuses: string[] = [];
        for (const deal of deals) {
            if (deal.contractType.trim() && !dealStatuses.includes(deal.contractType)) {
                dealStatuses.push(deal.contractType);
            }
        }
        return dealStatuses;
    }, [deals]);

    useEffect(() => {
        // const typeFilteredDeals = deals.filter(deal => (dealTypesFilter.length ? dealTypesFilter.includes(deal.dealType) : true));
        // const statusFilteredDeals = typeFilteredDeals.filter(deal => (dealStatusFilter.length ? dealStatusFilter.includes(deal.contractType) : true));
        // const searchFilteredDeals = statusFilteredDeals.filter(
        //     deal => deal.title.toLowerCase().includes(searchValue.toLowerCase()) || deal.company.toLowerCase().includes(searchValue.toLowerCase())
        // );
        // const [minDate, maxDate] = dateFilter;
        // const dateFilteredDeals = searchFilteredDeals.filter(deal => {
        //     const compareDate = moment(deal.incomePeriod?.start);
        //     return !(compareDate.isBefore(minDate) || compareDate.isAfter(maxDate));
        // });
        // setFilteredDeals(dateFilteredDeals);
    }, [searchValue, deals, dealTypesFilter, dateFilter, dealStatusFilter]);

    return (
        <Grid container className={classNames.rightdrawer}>
            <Grid item className={classNames.addAndSearch}>
                <Box component="span" fontSize={20} fontWeight={600} mb={3}>
                    Add Deals
                </Box>

                <Search search={searchValue} onSearchChange={setSearchValue} className={css.search} />
            </Grid>

            <Grid item className={css.chipFilterContainer}>
                <div className={css.chipFilterWrapper}>
                    <Box pb={1}>
                        <Typography>Deal type filters:</Typography>
                    </Box>
                    <ChipsFilter chips={types} filters={dealTypesFilter} onFilterChange={setDealTypesFilter} className={css.chipFilter} />
                </div>
                <div className={css.chipFilterWrapper}>
                    <Box pb={1}>
                        <Typography>Deal status filters:</Typography>
                    </Box>
                    <ChipsFilter chips={statuses} filters={dealStatusFilter} onFilterChange={setDealStatusFilter} className={css.chipFilter} />
                </div>
            </Grid>

            <Grid item className={classNames.startToendDate}>
                <Box component="div" mb={2} className={css.dateSearchContainer}>
                    <LocalizationProvider dateAdapter={MomentUtils}>
                        <DateRangePicker
                            startText="Start Date"
                            endText="End Date"
                            value={dateFilter}
                            inputFormat={selectedDateFormat}
                            onChange={newValue => setDateFilter(newValue)}
                            renderInput={(startProps, endProps) => (
                                <React.Fragment>
                                    <TextField {...startProps} variant="standard" />
                                    <DateRangeDelimiter> To </DateRangeDelimiter>
                                    <TextField {...endProps} variant="standard" />
                                </React.Fragment>
                            )}
                        />
                    </LocalizationProvider>
                </Box>
            </Grid>
            <Grid item className={classNames.rightdrawer}>
                {/* fixed height with internal scroll bar */}
                <Grid item className={classNames.rightdrawerCards}>
                    {/* sing Deal card*/}
                    {/* <DealCard title={'10000'} />

                    <DealCard title={'10000'} />

                    <DealCard title={'10000'} />
                    <DealCard title={'10000'} /> */}
                </Grid>
            </Grid>
        </Grid>
    );
};
